import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {PullRequestActiveRoute} from '../hooks/use-active-route'

export interface PullRequestRouteConfig {
  /** Whether the layout should use full-width (files/changes/checks) or condensed (conversation/overview/commits). */
  layout: 'full-width' | 'condensed'
  /** Whether the docked side panel is supported on this route. */
  dockedPanelSupported: boolean
}

export function getRouteConfig(activeRoute: PullRequestActiveRoute): PullRequestRouteConfig {
  const overviewPanelEnabled = isFeatureEnabled('prs_overview_panel')
  const routeConfigs: Record<PullRequestActiveRoute, PullRequestRouteConfig> = {
    overview: {
      layout: overviewPanelEnabled ? 'full-width' : 'condensed',
      dockedPanelSupported: overviewPanelEnabled,
    },
    conversation: {
      layout: 'condensed',
      dockedPanelSupported: false,
    },
    files_changed: {
      layout: 'full-width',
      dockedPanelSupported: true,
    },
    commits: {
      layout: 'condensed',
      dockedPanelSupported: false,
    },
    checks: {
      layout: 'full-width',
      dockedPanelSupported: false,
    },
    findings: {
      layout: 'condensed',
      dockedPanelSupported: false,
    },
    walkthrough: {
      layout: 'full-width',
      dockedPanelSupported: false,
    },
  }
  return routeConfigs[activeRoute]
}
